// 1mm  = 3.7795 px
export const PX_PER_MM = 3.7795;

export interface DragEndResult {
	readonly destinationBlockId: string | null;
	readonly sourceBlockId: string | null;
	readonly destinationPageBlocks: string[];
	readonly sourcePageBlocks: string[];
	readonly destinationPageNumber: number;
	readonly sourcePageNumber: number;
}

export enum EditorType {
	GROW_DOCUMENT = "grewDocument",
	GROW_TEMPLATE = "growTemplate"
}

export * from "./ImportProducts";
